import api from "@/services/api"
import type { PairDeviceResponse } from "@/services/pairDevice"

export type PairTerminalWebAppDeviceBody = {
  token: string
  serialNumber: string
  deviceSecret: string
  appVersion: string
  model?: string
  operatingSystem?: string
  webViewVersion?: string
}

export const pairTerminalWebAppDevice = async (
  payload: PairTerminalWebAppDeviceBody
) => {
  const { body } = await api.post<PairDeviceResponse>(
    "/auth/terminal-web-app/pair-device/",
    {
      body: payload,
      auth: undefined,
      version: 3,
    }
  )

  return body
}
